import * as Exchange from './ews'
import OutlookItem from './item'
import OutlookUserProfile from './userProfile'
import OutlookMailbox from './mailbox'
import OutlookNotifications from './notifications'
import { addBreadcrumb, setHostData } from '../sentry-config'
import * as GraphApi from './graphApi'

export const getOffice = () => Office

export class OfficeWrapper {
  currentCommandEvent!: Office.AddinCommands.Event
  office!: typeof Office
  notifications!: OutlookNotifications
  item!: OutlookItem
  userProfile!: OutlookUserProfile
  mailbox!: OutlookMailbox
  exchange!: typeof Exchange
  graphApi!: typeof GraphApi

  constructor(office: typeof Office) {
    this.office = office
  }

  componentWillReceiveOffice(office: typeof Office) {
    this.notifications = new OutlookNotifications(office)
    this.item = new OutlookItem(office)
    this.userProfile = new OutlookUserProfile(office)
    this.mailbox = new OutlookMailbox(office)
    this.exchange = Exchange
    this.graphApi = GraphApi
  }

  get isCommandContext() {
    return window.location.pathname === '/functions'
  }

  isComposeMode() {
    return !this.item.hasItemId()
  }

  terminateApp(options = { closeItem: false }) {
    if (options.closeItem) {
      this.item.close()
    }

    if (this.currentCommandEvent) {
      this.currentCommandEvent.completed()
    }
  }

  registerCommands(commands: any) {
    if (!this.isCommandContext) {
      return this
    }
    const makeGloballyAvailable = ([name, command]: [any, any]) => {
      window[name] = command
    }
    Object.entries(commands).forEach(makeGloballyAvailable)
    return this
  }

  async setOffice() {
    this.componentWillReceiveOffice(this.office)
  }

  async initialize() {
    const reason = await new Promise(resolve => {
      this.office.initialize = resolve
    })

    this.componentWillReceiveOffice(this.office)

    // @ts-expect-error `isDialog` is not documented but referenced in the office-js discussions couple times
    if (this.office.context.isDialog) {
      addBreadcrumb({ message: 'Opening dialog window', category: 'office-js' })
      return reason
    }

    this.setTrackingContext()

    if (
      !this.isComposeMode() &&
      this.office.context.requirements.isSetSupported('Mailbox', '1.5')
    ) {
      this.office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, () => {
        addBreadcrumb({ message: 'Office ItemChanged', category: 'office-js' })
      })
    }

    return reason
  }

  get requirementSet() {
    return this.guessRequirementSet()
  }

  guessRequirementSet() {
    const requirementSetOptions = [
      '1.15',
      '1.14',
      '1.13',
      '1.12',
      '1.11',
      '1.10',
      '1.9',
      '1.8',
      '1.7',
      '1.6',
      '1.5',
      '1.4',
      '1.3',
    ]

    const guess = requirementSetOptions.find(v =>
      this.office.context.requirements.isSetSupported('Mailbox', v)
    )

    return guess || 'unknown'
  }

  setTrackingContext() {
    setHostData(this.requirementSet)
  }
}

/* global Office */
export default new OfficeWrapper(Office)
